import { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import {Formik, Field, Form} from 'formik'
import {JSONFetcher, FormGroup, Button, FormTextArea, FormCentsInput, DISHtml} from 'shared'

export const EditButton = (props) => {
  const [showForm, setShowForm] = useState(false)
  const [data, setData] = useState(props)
  const handleClose = () => setShowForm(false)
  const handleShow = () => setShowForm(true)

return <>
    <button className='nowrap mr-md-2 simulated-link' onClick={handleShow}>{I18n.t(`modules.need_editor.edit_${props.locale}_link`)}</button>

    <Modal size='lg' className='generic-modal-window' show={showForm} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{I18n.t(`modules.need_editor.edit_modal_headline_${props.locale}`)}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div dangerouslySetInnerHTML={{__html: props.content}} />
        {props.children}
        <FormContent {...data} setData={setData} closeModal={handleClose} />
      </Modal.Body>
    </Modal>

  </>
}

const buildInitialValues = (props) => {
  return {
    de: {
      name_de: props.nameDe,
      summary_de: props.summaryDe,
      requested_amount_in_cents: props.requestedAmountInCents,
    },
    en: {
      name_en: props.nameEn,
      summary_en: props.summaryEn,
      requested_amount_in_cents: props.requestedAmountInCents,
    },
  }[props.locale]
}

const FormContent = (props) => {
  const initialValues = buildInitialValues(props)

  const submitHandler = (values) => {
    JSONFetcher.put({
      url: props.updateUrl,
      jsonObject: {need: values},
      success: () => window.location.reload()
    })
  }

  const validate = (values) => {
    const errors = {}
    const maxAmount = 9999
    if (!values.requested_amount_in_cents) errors.requested_amount_in_cents = I18n.t('misc.required_field')
    else if (values.requested_amount_in_cents > maxAmount * 100) errors.requested_amount_in_cents = I18n.t('errors.messages.less_than_or_equal_to', { count: maxAmount })
    return errors
  }

  return <Formik
    initialValues={initialValues}
    onSubmit={submitHandler}
    validate={validate}
  >
    {formikProps => <Form>
      <Field name={`name_${props.locale}`} label={I18n.t('modules.need_editor.name_label')} hint={I18n.t('modules.need_editor.name_hint')} component={FormGroup} />
      <Field name='requested_amount_in_cents' label={I18n.t('modules.need_editor.requested_amount_label')} hint={I18n.t('modules.need_editor.requested_amount_hint')} component={FormCentsInput} />

      <Field name={`summary_${props.locale}`} label={I18n.t('modules.need_editor.summary_label')} hint={I18n.t('modules.need_editor.summary_hint')} component={FormTextArea} maxLength={250} rows={3} />

      <Button type='submit' loading={formikProps.isSubmitting} className='btn-large btn-primary'>
        {I18n.t('verbs.save')}
      </Button>
      <div className='help-block'>
        <h3 className='text-2xl'>{I18n.t('modules.need_editor.notes_label')}</h3>
        <ul>
          <li>{I18n.t('modules.need_editor.note_precision')}</li>
          <li>{I18n.t('modules.need_editor.note_edit')}</li>
        </ul>
      </div>
    </Form>}
  </Formik>
}
